import { MemdbBoolean } from "./core.js";
import { createSchema } from "./createSchema.js";
import { getTournamentsByDate, Schack4anPointSystem, TournamentType, } from "./tournament.js";
const tournamentListingSchema = createSchema({
    id: 1,
    name: 1,
    start: 1,
    type: 1,
    message: 1,
    online: 1,
    showPublic: 1,
    classes: [
        {
            groups: [
                {
                    id: 1,
                    name: 1,
                    start: 1,
                    end: 1,
                    arenaStart: 1,
                    arenaEnd: 1,
                    status: 1,
                    classListRequired: 1,
                    schack4anteampointsystem: 1,
                    sort: [["order"], ["id"]],
                },
            ],
            sort: [
                ["order", "desc"],
                ["id", "desc"],
            ],
        },
    ],
    district: { id: 1, name: 1 },
});
export const getTournamentsForListing = (type) => getTournamentsByDate({
    start: new Date(Date.now() - 24 * 60 * 60 * 1000).toLocaleDateString("sv-SE"),
    end: "9999-01-01",
    type,
    schema: [tournamentListingSchema],
});
export const hasNormalPointSystem = (tournament) => tournament.classes.some(({ groups }) => groups.some((group) => group.schack4anteampointsystem === Schack4anPointSystem.Normal));
export const hasOpenRegistration = (tournament) => tournament.classes.some(({ groups }) => groups.some((group) => group.status === MemdbBoolean.True));
export const compareOpenRegistrationFirst = (a, b) => Number(hasOpenRegistration(b)) - Number(hasOpenRegistration(a));
export const isListedInRegWeb = (tournament) => tournament.online === MemdbBoolean.True &&
    tournament.showPublic === 1 &&
    (tournament.type === TournamentType.Individual ||
        (tournament.type === TournamentType.Schackfyran &&
            hasNormalPointSystem(tournament)));
export const isListedInS4Web = (tournament) => tournament.type === TournamentType.Schackfyran &&
    !hasNormalPointSystem(tournament);
//# sourceMappingURL=tournamentListings.js.map